import { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { Home, Views, Viewer, Reports, Catalog, Pending, Issues, Preview, Workflows, Settings, Profile } from "views";
import EventsEmitter from "events/EventsEmitter";
import AuthService, { ConnectionState } from "services/AuthService";

export default function Switcher() {
    useEffect(() => {
        if (AuthService.tokenResponse !== null) {
            const { expiresOn } = AuthService.tokenResponse;
            //const currenDateGMT = new Date();
            //console.log("Token will expires at:", expiresOn, "|now is:", currenDateGMT);
            if (new Date(expiresOn).getTime() <= new Date().getTime()) {
                //console.log("Authentication has expired...request another token");
                AuthService.accessToken = "";
                AuthService.connectionState = ConnectionState.NEEDS_LOGIN;
                EventsEmitter.emit("authExpires", {});
            }
        }
    });
    return (
        <Switch>
            <Route path="/views/:viewId" exact>
                <Viewer />
            </Route>
            <Route path="/preview/:entityId" exact>
                <Preview />
            </Route>
            <Route path="/views" exact>
                <Views />
            </Route>
            <Route path="/workflows" exact>
                <Workflows />
            </Route>
            <Route path="/reports" exact>
                <Reports />
            </Route>
            <Route path="/catalog/:catalogId" exact>
                <Catalog />
            </Route>
            <Route path="/catalog" exact>
                <Catalog />
            </Route>
            <Route path="/pending" exact>
                <Pending />
            </Route>
            <Route path="/issues" exact>
                <Issues />
            </Route>
            <Route path="/settings/:mode" exact>
                <Settings />
            </Route>
            <Route path="/settings" exact>
                <Settings />
            </Route>
            <Route path="/profile/:defaultTab?" exact>
                <Profile />
            </Route>
            <Route path="/" exact>
                <Home />
            </Route>
        </Switch>
    );
}
